// extracted by mini-css-extract-plugin
module.exports = {"root":"Images-module--root--2AuSL","image":"Images-module--image--3YLer"};